"use strict";

define('service/modal',['require','exports','module','appkit/service','underscore','backbone','handlebars','appkit/changes.helper','uikit/uikit'],function (require, exports, module) {
  var Service = require('appkit/service');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Handlebars = require('handlebars');
  var ChangesHelper = require('appkit/changes.helper');
  var UIKit = require('uikit/uikit');
  var ModalService = Service.extend({
    replies: {
      'modal': 'modalByType'
    },
    confirmationModal: function confirmationModal(options, modalOptions) {
      var modal = new UIKit.Modal(_.extend({
          actions: 'default',
          basic: true
        }, modalOptions || {})),
        denyBtn = _.extend({
          text: 'Cancel',
          inverted: true,
          color: 'basic'
        }, options.denyBtn),
        approveBtn = _.extend({
          text: 'Confirm',
          color: 'positive'
        }, options.approveBtn);
      modal.content.icon = options.icon || 'send outline icon';
      modal.header.text = options.header;
      modal.content.text = options.content;
      modal.actions.addDeny(new UIKit.Button(denyBtn)).addApprove(new UIKit.Button(approveBtn));
      modal.on('approve', function () {
        modal.visible = false;
      }).on('deny', function () {
        modal.visible = false;
      }).on('modal:hidden', function () {
        modal.destroy();
      });
      _.defer(function () {
        modal.visible = true;
      });
      return modal;
    },
    unsavedChangesModal: function unsavedChangesModal(options, modalOptions) {
      var lastFragment = null,
        unsavedChanges = false,
        currentFragment = Backbone.history.fragment,
        state = options.state,
        modal = new UIKit.Modal(_.extend({
          actions: 'default',
          basic: true
        }, modalOptions));
      modal.content.icon = 'file text outline';
      modal.content.text = "Would you like to save these changes before you leave the " + (options.location || 'page') + "?";
      modal.header.text = "Unsaved Changes";
      modal.actions.addDeny(new UIKit.Button({
        text: "Don't Save",
        color: 'basic red',
        inverted: true,
        icon: 'remove'
      })).addApprove(new UIKit.Button({
        text: 'Save',
        color: 'positive',
        icon: 'save'
      }));
      var modalState = '',
        startedHiding = false;
      modal.listenTo(modal, 'approve', function () {
        var ev = _.extend({}, Backbone.Events).listenToOnce(state, 'change:' + ChangesHelper.UNSAVED_CHANGES, _.debounce(function () {
          ev.stopListening();
          _.defer(function () {
            modal.trigger('proceed', modalState);
          });
        })).listenToOnce(modal, 'modal:show', function () {
          ev.stopListening();
        });
        modalState = 'approved';
        modal.trigger('save:model', options);
      }).listenTo(modal, 'deny', function () {
        modalState = 'deny';
        state.set(ChangesHelper.UNSAVED_CHANGES, false);
        _.defer(function () {
          modal.trigger('proceed', modalState);
        });
      }).listenTo(modal, 'modal:hidden', function (ev) {
        startedHiding = false;
        if (!modalState && lastFragment) {
          Backbone.history.trigger('cancel:route');
        }
      }).listenTo(modal, 'proceed', function () {
        if (lastFragment) {
          app.navigate(lastFragment, {
            trigger: true,
            replace: true
          });
        }
      }).listenTo(modal, 'modal:hide', function () {
        startedHiding = true;
      });
      var destroy = modal.destroy;
      modal.destroy = function () {
        var args = _.toArray(arguments);
        modal.stopListening().off();
        if (startedHiding) {
          modal.once('modal:hidden', _.debounce(function () {
            destroy.apply(this, args);
          }));
        } else {
          destroy.apply(this, args);
        }
        return this;
      };
      modal.listenTo(Backbone.history, 'before:route', function (router, name, ev) {
        lastFragment = ev.fragment;
        if (state.get(ChangesHelper.UNSAVED_CHANGES)) {
          ev.preventDefault = true;
          modal.visible = true;
          app.navigate(currentFragment, {
            replace: true
          });
        } else {
          modal.once('modal:hidden', _.debounce(function () {
            modal.destroy();
          }, 1));
          modal.visible = false;
        }
      });
      return modal;
    },
    statelessUnsavedChangesModal: function statelessUnsavedChangesModal(options, modalOptions) {
      var modal = new UIKit.Modal(_.extend({
        actions: 'default',
        basic: true
      }, modalOptions));
      modal.content.icon = 'file text outline';
      modal.content.text = "Would you like to save these changes?";
      modal.header.text = "Unsaved Changes";
      modal.actions.addDeny(new UIKit.Button({
        text: "Don't Save",
        color: 'basic red',
        inverted: true,
        icon: 'remove'
      })).addApprove(new UIKit.Button({
        text: 'Save',
        color: 'positive',
        icon: 'save'
      }));
      return modal;
    },
    confirmDestroyModal: function confirmDestroyModal(options, modalOptions) {
      options = options || {};
      var events = _.extend({}, Backbone.Events),
        lastFragment = '',
        unsavedChanges = false,
        currentFragment = Backbone.history.fragment,
        action = options.action || 'Delete',
        modal = new UIKit.Modal(_.extend({
          actions: 'default',
          basic: true
        }, modalOptions));
      modal.content.icon = 'trash outline';
      modal.header.text = options.headerText || action + " " + (options.entity ? options.entity : "Item");
      modal.content.text = options.contentText || new Handlebars.SafeString("Are you sure you want to " + action.toLowerCase() + " " + (options.name ? '<i>"' + Handlebars.escapeExpression(options.name) + '"</i>' : "this item") + " ?");
      modal.actions.addDeny(new UIKit.Button({
        text: "Cancel",
        inverted: true,
        color: 'basic'
      })).addApprove(new UIKit.Button({
        text: action,
        color: options.actionColor || 'negative',
        icon: options.actionIcon || 'remove'
      }));
      events.listenTo(modal, 'approve', function () {
        events.trigger('destroy:model', options);
        events.trigger('confirm', options);
        events.trigger('approve', options);
        modal.visible = false;
      }).listenTo(modal, 'deny', function () {
        modal.visible = false;
      }).listenTo(modal, 'modal:hidden', function () {
        events.stopListening();
        events.off();
        modal.destroy();
      }).listenTo(Backbone.history, 'route', function () {
        modal.visible = false;
      });
      modal.visible = true;
      return events;
    },
    modalByType: function modalByType(options, modalOptions) {
      var type = options.type,
        state = options.state,
        options = _.omit(options, 'type');
      switch (type) {
        case 'UNSAVED_CHANGES':
          if (state) {
            return this.unsavedChangesModal(options, modalOptions);
          } else {
            return this.statelessUnsavedChangesModal(options, modalOptions);
          }
          break;
        case 'CONFIRM_DESTROY':
          return this.confirmDestroyModal(options, modalOptions);
        case 'CONFIRM':
          return this.confirmationModal(options, modalOptions);
      }
    }
  });
  module.exports = ModalService;
});

